const STORAGE_KEY = 'loyalty_reservation_approvals_seen';

function normalizeId(id) {
  return id == null ? '' : String(id);
}

function readSeenIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = JSON.parse(raw || '[]');
    return Array.isArray(parsed) ? parsed.map(normalizeId) : [];
  } catch {
    return [];
  }
}

export function hasSeenReservationApproval(reservationId) {
  const id = normalizeId(reservationId);
  if (!id) return false;
  return readSeenIds().includes(id);
}

export function markReservationApprovalSeen(reservationId) {
  const id = normalizeId(reservationId);
  if (!id) return;

  const seen = readSeenIds();
  if (seen.includes(id)) return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...seen, id]));
}

export function findUnseenApprovedReservations(reservations) {
  const seen = new Set(readSeenIds());
  const now = new Date();

  return (Array.isArray(reservations) ? reservations : [])
    .filter((reservation) => {
      const id = normalizeId(reservation.id);
      if (!id || reservation.status !== 'confirmed') return false;
      if (seen.has(id)) return false;
      if (!reservation.reserved_at) return false;
      return new Date(reservation.reserved_at) >= now;
    })
    .sort((a, b) => new Date(a.reserved_at) - new Date(b.reserved_at));
}
